import {
  CLEAR_EARTHQUAKE_INFO,
  GET_EARTHQUAKE_INFO_REFERENCES_REQUEST,
  GET_EARTHQUAKE_INFO_REQUEST,
  EARTHQUAKE_INFO_REFERENCE_SORT,
  EARTHQUAKE_INFO_TOGGLE_COLUMN,
} from './earthquakeInfoReducer';

export const clearEarthquakeInfo = () => ({ type: CLEAR_EARTHQUAKE_INFO });
export const getEarthquakeInfo = ({ id, history }) => ({ type: GET_EARTHQUAKE_INFO_REQUEST, id, history });
export const getEarthquakeReferences = ({ id, history }) => ({ type: GET_EARTHQUAKE_INFO_REFERENCES_REQUEST, id, history });
export const sortReferences = sort => ({ type: EARTHQUAKE_INFO_REFERENCE_SORT, sort });
export const toggleColumns = visibleColumns => ({ type: EARTHQUAKE_INFO_TOGGLE_COLUMN, visibleColumns });
